import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import qs from 'qs';
import { Card, CardBody, CardTitle } from 'reactstrap';
import {
  searchRunups as searchRunupsAc,
  clearRedirect as clearRedirectAc,
  clearRunupSearch as clearRunupSearchAc,
} from '../../../../../../redux/tsunamis/runups/search/runupSearchActions';
import {
  deleteRunup as deleteRunupAc,
  getCauses as getCausesAc,
  getRegions as getRegionsAc,
  getRunupRegions as getRunupRegionsAc,
  getValidity as getValidityAc,
  getRunupMeasurementTypes as getRunupMeasurementTypesAc,
  clearRunupData as clearRunupDataAc,
  sortData as sortDataAc,
  toggleColumns as toggleColumnsAc,
} from '../../../../../../redux/tsunamis/runups/data/runupDataActions';
import { isDataManager } from '../../../../../../role/roleUtils';
import { SearchParamDisplay } from '../../../../../data/SearchParamDisplay';
import { resolveSearchParameters } from '../search/runupSearchParameterNameResolver';
import { Loading } from '../../../../../loadbar/Loading';
import { RunupDataGrid } from './RunupDataGrid';

class RunupContainerUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.toggleDescriptionModal = this.toggleDescriptionModal.bind(this);
    this.state = {
      queryParameters: {},
    };
  }


  componentDidMount() {
    document.title = 'NCEI Hazard Runup Results';
    const {
      clearRunupData,
      getCauses,
      getRunupMeasurementTypes,
      getValidity,
      getRegions,
      getRunupRegions,
      searchRunups,
      clearRedirect,
      searchRedirect,
      location: { search },
      history,
    } = this.props;
    clearRunupData();
    getCauses({ history });
    getRunupMeasurementTypes({ history });
    getValidity({ history });
    getRegions({ history });
    getRunupRegions({ history });
    let queryParameters = {};
    if (search.length) {
      queryParameters = qs.parse(search.split('?')[1]);
    }
    if (!searchRedirect) {
      searchRunups({ queryParameters, history });
    } else {
      clearRedirect();
    }
    this.setState({ queryParameters });
  }

  componentWillUnmount() {
    const { clearRunupSearch, clearRunupData } = this.props;
    clearRunupSearch();
    clearRunupData();
  }

  toggleDescriptionModal(name) {
    this.setState(state => ({ modals: state.modals.update(name, val => !val) }));
  }


  render() {
    const {
      runups,
      fetched,
      deleting,
      authorities,
      regions,
      runupRegions,
      peopleDescriptors,
      damageDescriptors,
      housesDescriptors,
      validities,
      causes,
      runupMeasurementTypes,
      sort,
      sortData,
      visibleColumns,
      toggleColumns,
      history,
      deleteRunup,
      searchRunups,
    } = this.props;
    const { queryParameters } = this.state;

    const dataManager = isDataManager(authorities);

    if (!fetched) {
      return (<Loading />);
    }

    const sp = resolveSearchParameters({
      params: queryParameters,
      regions,
      runupRegions,
      peopleDescriptors,
      damageDescriptors,
      housesDescriptors,
      validities,
      causes,
      runupMeasurementTypes,
    });

    return (
      <div className="haz-results-container haz-page-container">
        {/* <YearModal toggle={() => this.toggleDescriptionModal('YearModal')} isOpen={modals.get('YearModal')} /> */}
        {/* <MonthModal toggle={() => this.toggleDescriptionModal('MonthModal')} isOpen={modals.get('MonthModal')} /> */}
        {/* <DayModal toggle={() => this.toggleDescriptionModal('DayModal')} isOpen={modals.get('DayModal')} /> */}
        {/* <HourModal toggle={() => this.toggleDescriptionModal('HourModal')} isOpen={modals.get('HourModal')} /> */}
        {/* <MinuteModal toggle={() => this.toggleDescriptionModal('MinuteModal')} isOpen={modals.get('MinuteModal')} /> */}
        {/* <SecondModal toggle={() => this.toggleDescriptionModal('SecondModal')} isOpen={modals.get('SecondModal')} /> */}
        {Boolean(sp.length) && <SearchParamDisplay messages={sp} />}

        <div className="haz-data-grid-container">
          <div className="haz-data-grid-container">
            <Card>
              <CardBody>

                <div className="doiCitation">
                  <span id="doiReference">
                    <p>
                      <a href="http://dx.doi.org/10.7289/V5PN93H7" rel="noopener noreferrer" target="_blank" title="Tsunami Runup Information" aria-label="Tsunami Runup Information">Please cite DOI:10.7289/V5PN93H7</a>
                    </p>
                  </span>
                </div>


                <CardTitle tag="h2">{`Runups - ${runups.size} Results Found`}</CardTitle>

                <RunupDataGrid
                  runups={runups}
                  dataManager={dataManager}
                  sort={sort}
                  sortData={sortData}
                  visibleColumns={visibleColumns}
                  toggleColumns={toggleColumns}
                  searchParams={JSON.stringify(sp)}
                  deleting={deleting}
                  deleteRunup={deleteRunup}
                  onDeleteCloseModal={() => searchRunups({ queryParameters, history })}
                />

              </CardBody>
            </Card>
          </div>
        </div>

      </div>
    );
  }
}

RunupContainerUnwrapped.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  fetched: PropTypes.bool.isRequired,
  deleting: PropTypes.bool.isRequired,
  runups: ImmutablePropTypes.list.isRequired,
  searchRunups: PropTypes.func.isRequired,
  clearRunupSearch: PropTypes.func.isRequired,
  deleteRunup: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired,
  clearRedirect: PropTypes.func.isRequired,
  searchRedirect: PropTypes.bool.isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
  getRunupMeasurementTypes: PropTypes.func.isRequired,
  runupMeasurementTypes: ImmutablePropTypes.list.isRequired,
  peopleDescriptors: ImmutablePropTypes.list.isRequired,
  damageDescriptors: ImmutablePropTypes.list.isRequired,
  housesDescriptors: ImmutablePropTypes.list.isRequired,
  validities: ImmutablePropTypes.list.isRequired,
  getValidity: PropTypes.func.isRequired,
  causes: ImmutablePropTypes.list.isRequired,
  getCauses: PropTypes.func.isRequired,
  clearRunupData: PropTypes.func.isRequired,
  regions: ImmutablePropTypes.list.isRequired,
  getRegions: PropTypes.func.isRequired,
  runupRegions: ImmutablePropTypes.list.isRequired,
  getRunupRegions: PropTypes.func.isRequired,
  sortData: PropTypes.func.isRequired,
  sort: ImmutablePropTypes.list.isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
  toggleColumns: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  fetched: [
    state.getIn(['runupSearchPage', 'fetched']),
    state.getIn(['runupDataPage', 'fetchedRegions']),
    state.getIn(['runupDataPage', 'fetchedRunupRegions']),
    state.getIn(['runupDataPage', 'fetchedRunupMeasurementTypes']),
    state.getIn(['runupDataPage', 'fetchedValidities']),
    state.getIn(['runupDataPage', 'fetchedCauses']),
  ].every(v => v),
  deleting: state.getIn(['runupDataPage', 'deleting']),
  runups: state.getIn(['runupSearchPage', 'runups']),
  searchRedirect: state.getIn(['runupSearchPage', 'searchRedirect']),
  validities: state.getIn(['runupDataPage', 'validities']),
  causes: state.getIn(['runupDataPage', 'causes']),
  regions: state.getIn(['runupDataPage', 'regions']),
  runupRegions: state.getIn(['runupDataPage', 'runupRegions']),
  runupMeasurementTypes: state.getIn(['runupDataPage', 'runupMeasurementTypes']),
  damageDescriptors: state.getIn(['effectDescriptors', 'damage']),
  peopleDescriptors: state.getIn(['effectDescriptors', 'people']),
  housesDescriptors: state.getIn(['effectDescriptors', 'houses']),
  sort: state.getIn(['runupSearchPage', 'sort']),
  visibleColumns: state.getIn(['runupDataPage', 'visibleColumns']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  searchRunups: searchRunupsAc,
  clearRunupSearch: clearRunupSearchAc,
  deleteRunup: deleteRunupAc,
  clearRedirect: clearRedirectAc,
  getCauses: getCausesAc,
  getRegions: getRegionsAc,
  getRunupRegions: getRunupRegionsAc,
  getValidity: getValidityAc,
  getRunupMeasurementTypes: getRunupMeasurementTypesAc,
  clearRunupData: clearRunupDataAc,
  sortData: sortDataAc,
  toggleColumns: toggleColumnsAc,
}, dispatch);


export const RunupContainer = connect(mapStateToProps, mapDispatchToProps)(RunupContainerUnwrapped);
